<template>
  <div class="wrapper">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/background/exam/platform-question' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <el-form class="form-style" :model="form" size="mini" :inline="true">
        <el-form-item label="试题类型">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option value="" label="全部"></el-option>
            <el-option value="1" label="单选题"></el-option>
            <el-option value="2" label="多选题"></el-option>
            <el-option value="3" label="判断题"></el-option>
            <el-option value="4" label="填空题"></el-option>
            <el-option value="5" label="简单题"></el-option>
            <el-option value="6" label="综合题"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="试题名称" prop="title">
          <el-input style="width: 200px" v-model="form.question_title" placeholder="请输入名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="search_btn" plain size="mini" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button class="search_btn" plain size="mini" icon="" @click="AddQuestion">添加试题</el-button>

        </el-form-item>
      </el-form>
    </div>

    <div class="questions">
      <el-table size="mini" @expand-change="expandChange" :data="questionlist"
        :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div v-if="props.row.show_type === 1">
              <div class="question_title" v-html="props.row.title"></div>
            </div>
            <div v-else>
              <div class="question_title">
                <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.title_md"
                  defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false"
                  :toolbarsFlag="false"></mavon-editor>
              </div>
            </div>
            <div v-if="props.row.show_type === 1">
              <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                <div v-if="item.content" class="options_title">
                  {{ item.title }}、
                </div>

                <div v-if="item.content" class="options_content">
                  <div class="content" v-html="item.content"></div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="props.row.type == '3'">
                <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                  <div v-if="item.content" class="options_title">
                    {{ item.title }}、
                  </div>

                  <div v-if="item.content" class="options_content">
                    <div class="content" v-html="item.content"></div>
                  </div>
                </div>
              </div>
              <div v-else class="options" v-for="(item, index) of JSON.parse(props.row.options_md)" :key="index">
                <div v-if="item.content" class="options_title">
                  {{ item.title }}、
                </div>

                <div v-if="item.content" class="options_content">
                  <div class="content">
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.content"
                      defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false"
                      :toolbarsFlag="false"></mavon-editor>
                  </div>
                </div>
              </div>

            </div>

            <div class="answer">
              <span class="answer_label">正确答案:</span>
              <span v-if="props.row.type == '1' ||
          props.row.type == '2' ||
          props.row.type == '3' ||
          props.row.type == '4'
          " class="answer_content" v-html="props.row.answer"></span>
              <span v-else-if="props.row.type == '5'">简答题答案</span>
              <span v-else-if="props.row.type == '6'">综合题答案</span>
            </div>

            <div class="analysis">
              <span class="analysis_label">试题解析:</span>
              <span v-if="props.row.show_type === 1" class="analysis_content" v-html="props.row.analysis"></span>
              <span v-else class="analysis_content">
                <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.analysis_md"
                  defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false"
                  :toolbarsFlag="false"></mavon-editor>

              </span>

            </div>
          </template>
        </el-table-column>

        <el-table-column align="left" width="50" label="序号">

          <template slot-scope="scope">
            <span>{{ scope.$index + (page_no - 1) * 20 + 1 }}</span>
          </template>

        </el-table-column>

        <el-table-column align="left" label="题型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">单选题</span>
            <span v-else-if="scope.row.type == 2">多选题</span>
            <span v-else-if="scope.row.type == 3">判断题</span>
            <span v-else-if="scope.row.type == 4">填空题</span>
            <span v-else-if="scope.row.type == 5">简答题</span>
            <span v-else-if="scope.row.type == 6">综合题</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="题目" prop="title_str">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.title_str" placement="top-start">
              <span style="
                  max-width: 150px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                ">{{ scope.row.title_str }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="答案">
          <template slot-scope="scope">
            <span v-if="scope.row.type == '1' ||
          scope.row.type == '2' ||
          scope.row.type == '3'
          ">{{ scope.row.answer }}</span>
            <span v-else-if="scope.row.type == '4'">{{ scope.row.answer }}</span>
            <span v-else-if="scope.row.type == '5'">综合题答案</span>
          </template>
          <span></span>
        </el-table-column>

        <el-table-column align="center" width="150" label="创建时间" prop="created_time">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-link class="question_btn" type="primary" @click="EditQuestion(scope.row)">编辑</el-link>
            <el-link class="question_btn" type="primary" :disabled="scope.row.educational_institution_id != null"
              @click="DeleteQuestion(scope.row.id)">删除</el-link>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page_no"
        layout="total, prev, pager, next" :page-size="page_size" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import Prism from "prismjs"; //引入插件

import { adminGetQuestionList, adminDeleteQuestion } from "@/api/admin";
import getcode from "@/config/getCodesStyle";


export default {
  name: "questionlist-admin",
  data() {
    return {
      form: {
        question_title: "",
        type: "",
      },
      title: "",
      questionlist: [],
      bank_id: "",
      page_no: 1,
      page_size: 20,
      total: 0,
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.bank_id = this.$route.query.id;

    this.adminGetQuestionList();
  },
  methods: {
    expandChange(row) {
      console.log(1212);
      console.log(row, 4512);
      if (row.show_type === 1) {
        this.$nextTick(() => {
          Prism.highlightAll()
        })
      } else {
        this.$nextTick(() => {
          getcode()
        })

      }


    },
    search() {
      this.page_no = 1;
      this.adminGetQuestionList();
    },
    AddQuestion() {
      this.$router.push({
        name: "add-question-admin",
        query: {
          id: this.$route.query.id,
          title: this.$route.query.title,
          subject_id: this.$route.query.subject_id,
          question_num: this.total,
          type: '2'
        },
      });
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetQuestionList();
    },
    EditQuestion(row) {
      console.log("编辑题目");
      console.log(row, 123465);

      this.$router.push({
        name: "add-question-admin",
        query: {
          id: this.bank_id,
          title: this.title,
          subject_id: row.subject_id,
          schoolId: row.educational_institution_id,
          type: '3',
          question_num: row.sort_num,
        },
        params: {
          question: row
        }
      });
      sessionStorage.setItem("ExamData", JSON.stringify(row));

    },

    DeleteQuestion(id) {
      console.log("删除题目");
      console.log(id);

      this.$confirm("确定删除本道题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteQuestion({
          questionId: id,
        }).then((res) => {
          console.log("删除题目");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetQuestionList();
          }
        });
      });
    },


    adminGetQuestionList() {
      adminGetQuestionList({
        questionBankId: this.bank_id,
        title_str: this.form.question_title,
        type: this.form.type,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("题目列表");
        console.log(res);
        this.total = res.total;
        this.questionlist = res.questionList;
        res.questionList.map((item, index) => {
          console.log(item, 4512);
          console.log(index, 4512);
          if (item.show_type === 1) {
            console.log(index, 4512);
            this.$nextTick(() => {
              Prism.highlightAll()
            })
          } else {
            this.$nextTick(() => {
              getcode()
            })
          }

        })
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;

  .header {
    margin-top: 20px;

    .search {
      width: 250px;
    }

    .search_btn {
      margin-left: 20px;
    }
  }

  .questions {
    .question_title {
      font-weight: bold;
      font-size: 16px;
    }

    .options {
      margin-top: 20px;
      float: left;
      width: 100%;

      .options_title {
        float: left;
      }

      .options_content {
        float: left;
      }
    }

    .answer {
      margin-top: 20px;
      float: left;
      width: 50%;

      .answer_label {
        font-weight: bold;
      }

      .answer_content {
        margin-left: 10px;
        color: green;
        font-weight: bold;
      }
    }

    .analysis {
      margin-top: 20px;
      float: left;
      width: 50%;

      .analysis_label {
        font-weight: bold;
      }

      .analysis_content {}
    }

    .question_btn {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}

/deep/ .hljs {
  background: transparent;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}
</style>
